'use client';

import React from 'react';

export const defaultFocusMenuListContext: {
  expandedId: string | null;
  selectedId: string | null;
  dispatch: React.Dispatch<any> | undefined;
  menuRef: React.RefObject<HTMLElement> | null;
  focusNextEnabledChild: () => void;
  focusPrevEnabledChild: () => void;
} = {
  expandedId: null,
  selectedId: null,
  dispatch: undefined,
  menuRef: null,
  focusNextEnabledChild: () => {},
  focusPrevEnabledChild: () => {},
};

export const MenuListContext = React.createContext(defaultFocusMenuListContext);
